/* eslint-disable import/no-absolute-path */
/* eslint-disable import/no-unresolved */
import awsSVG from 'assets/resources/pages/software-services/logo/aws.svg';
import googlecloudSVG from 'assets/resources/pages/software-services/logo/googlecloud.svg';

export default [
  {
    src: awsSVG,
    nameClass: 'img-fluid',
    alt: 'Amazon Web Services'
  },
  {
    src: googlecloudSVG,
    nameClass: 'img-fluid',
    alt: 'Google Cloud Platform'
  }
]